export const generateScenarioFileUrl = (
  path: string,
  type: 'background' | 'character' | 'document' | 'column',
) => {
  const imageServerUrl = import.meta.env.VITE_SCENARIO_IMAGE_SERVER_URL;

  const typePaths: Record<typeof type, string> = {
    background: 'scenario/common/background/',
    character: 'scenario/common/character/',
    document: '',
    column: '',
  };

  return `${imageServerUrl}${typePaths[type]}${path}`;
};
